module.exports = __webpack_public_path__ + "static/media/tarjeta_agregada.041c3fef.svg";